import { Icon } from '@driftt/dds'
import { faPlus } from '@driftt/dds.icons/regular/faPlus'
import React from 'react'

export const PROMPT_MODES = {
  AI: 'AI',
  MANUAL: 'MANUAL',
} as const

export const AVAILABLE_OPERATORS = {
  GREATER_THAN: 'greater than',
  LESS_THAN: 'less than',
  IS_BETWEEN: 'is between',
  EQUAL: 'equals',
  NOT_EQUAL: 'does not equal',
  INCLUDES: 'in',
  EXCLUDES: 'not in',
  EXISTS: 'exists',
}

export const OPERATORS_LIST = Object.values(AVAILABLE_OPERATORS).map((v) => ({
  label: v,
  value: v,
}))

export const CONFIRMATION_TEXT_COPIES = {
  title: 'Update qualification rules?',
  description:
    'Are you sure you want to update these qualification rules? This action cannot be undone or reverted to a previous version.',
}

export const CREATE_ATTRIBUTE_OPTIONS = [
  {
    value: 'CREATE_CONTACT_ATTR',
    href: '/contacts/contact-settings',
    label: 'Create new contact attribute',
    prefix: <Icon icon={faPlus} />,
  },
]

export const QUALIFICATION_DEFAULT_NAME = 'Edit persona description'
